import { styled } from "styled-components";

export const DepositPopupWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  min-width: 440px;
  width: max-content;
  min-height: 366px;
  height: auto;
  border-radius: 13px;
  z-index: 1000;
  padding: 40px 15px 88px;
  box-sizing: border-box;
`;

export const DepositMemberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-family: Pretendard;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  span {
    font-weight: 600;
  }
`;

export const DepositMember = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  color: #7f25fb;

  > .member {
    width: max-content;
    height: 35px;
    border-radius: 10px;
    background: #7f25fb;
    color: #fff;
    padding: 0 24px;
    box-sizing: border-box;
    line-height: 35px;
  }

  > .log {
    cursor: pointer;
  }
`;

export const DepositContentWrapper = styled.div`
  margin-top: 22px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const DepositPaymentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  > .payment {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
  }
`;

export const DepositPaymentList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 44px;
  row-gap: 12px;
`;

export const DepositPaymentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  > .method {
    width: 92px;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 14.67px;
    line-height: 100%;
    text-align: center;
  }

  > input {
    width: 113px;
    height: 34px;
    border-radius: 9.78px;
    border: 1px solid #e5e5e5;
    text-align: center;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 14.67px;
    line-height: 100%;
    outline: none;
  }

  &.memo {
    grid-column: span 2;

    > input {
      flex: 1;
    }
  }
`;
